/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "vip_dl"
};
var _hoisted_2 = {
  "class": "container"
};
var _hoisted_3 = {
  "class": "row"
};
var _hoisted_4 = {
  "class": "vip_dl_con"
};
var _hoisted_5 = {
  "class": "vip_dl_fr"
};
var _hoisted_6 = {
  "class": "vip_dl_fr2"
};
var _hoisted_7 = {
  "class": "denglu block"
};
var _hoisted_8 = {
  "class": "denglu1"
};
var _hoisted_9 = {
  "class": "denglu1_con1 block"
};
var _hoisted_10 = {
  "class": "agreement"
};
var _hoisted_11 = {
  "class": "li5"
};
import { ElMessage } from "element-plus";
import { regApi, sendCaptchaApi } from "@/api/login/login";
export default /*@__PURE__*/_defineComponent({
  __name: 'Reg',
  setup: function setup(__props) {
    var router = useRouter();
    var ruleFormRef = ref();
    var rules = reactive({
      email: [{
        required: true,
        message: "请输入电子邮箱",
        trigger: "blur"
      }, {
        type: "email",
        message: "请输入正确的邮箱格式",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "请输入登录密码",
        trigger: "blur"
      }],
      confirmPsd: [{
        required: true,
        message: "请输入确认密码",
        trigger: "blur"
      }],
      code: [{
        required: true,
        message: "请输入验证码",
        trigger: "blur"
      }]
    });
    var timerOn = ref(false);
    var countdown = ref(60);
    var intervalId = 1;
    function sendCode() {
      return _sendCode.apply(this, arguments);
    }
    function _sendCode() {
      _sendCode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(loginData.value.email === "")) {
                _context.next = 3;
                break;
              }
              ElMessage.error('请输入电子邮箱');
              return _context.abrupt("return");
            case 3:
              if (!timerOn.value) {
                timerOn.value = true;
                countdown.value = 60;
                intervalId = setInterval(function () {
                  if (countdown.value > 0) {
                    countdown.value--;
                  } else {
                    clearInterval(intervalId);
                    timerOn.value = false;
                  }
                }, 1000);
              }
              _context.next = 6;
              return sendCaptchaApi(loginData.value.email);
            case 6:
              res = _context.sent;
              if (res.code === 200) {
                ElMessage.success(res.msg);
              } else {
                ElMessage.error(res.msg);
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _sendCode.apply(this, arguments);
    }
    var loginData = ref({
      email: "",
      password: "",
      confirmPsd: "",
      code: ''
    });
    function regUser(_x) {
      return _regUser.apply(this, arguments);
    }
    function _regUser() {
      _regUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(formEl) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (formEl) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.next = 4;
              return formEl.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(valid, fields) {
                  var response;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!valid) {
                          _context2.next = 8;
                          break;
                        }
                        _context2.next = 3;
                        return regApi(loginData.value);
                      case 3:
                        response = _context2.sent;
                        console.log(response);
                        if (response.code === 200) {
                          ElMessage.success('注册成功');
                          router.push("/login");
                        } else {
                          ElMessage.error(response.msg);
                        }
                        _context2.next = 9;
                        break;
                      case 8:
                        console.log("error submit!", fields);
                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _regUser.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _component_el_button = __unplugin_components_0;
      var _component_el_input = __unplugin_components_1;
      var _component_el_form_item = __unplugin_components_2;
      var _component_router_link = _resolveComponent("router-link");
      var _component_el_form = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[8] || (_cache[8] = _createElementVNode("h1", {
        "class": "hidden-xs"
      }, "注册", -1)), _cache[9] || (_cache[9] = _createElementVNode("ul", {
        "class": "welcome"
      }, " 提供有关您自己的信息是注册的第一步 ", -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_form, {
        rules: _unref(rules),
        model: _unref(loginData),
        ref_key: "ruleFormRef",
        ref: ruleFormRef
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form_item, {
            prop: "email",
            label: "电子邮箱"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _unref(loginData).email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(loginData).email = $event;
                }),
                placeholder: "请输入电子邮箱"
              }, {
                suffix: _withCtx(function () {
                  return [_createVNode(_component_el_button, {
                    type: "primary",
                    "class": "fasong",
                    disabled: _unref(timerOn),
                    onClick: sendCode
                  }, {
                    "default": _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref(timerOn) ? "".concat(_unref(countdown), "\u79D2\u540E\u91CD\u65B0\u83B7\u53D6") : '获取验证码'), 1)];
                    }),
                    _: 1
                  }, 8, ["disabled"])];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "code",
            label: "验证号码"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                modelValue: _unref(loginData).code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(loginData).code = $event;
                }),
                placeholder: "请输入验证码"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "password",
            label: "账号密码"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                type: "password",
                modelValue: _unref(loginData).password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(loginData).password = $event;
                }),
                placeholder: "请输入登录密码",
                style: {
                  "color": "#a9a9a9"
                }
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "confirmPsd",
            label: "密码确认"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_input, {
                type: "password",
                modelValue: _unref(loginData).confirmPsd,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return _unref(loginData).confirmPsd = $event;
                }),
                placeholder: "请输入登录密码"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, [_cache[6] || (_cache[6] = _createTextVNode("如果您已使用该邮箱注册过账号，请返回上一页面进行 ")), _createVNode(_component_router_link, {
            to: "/login"
          }, {
            "default": _withCtx(function () {
              return _cache[5] || (_cache[5] = [_createElementVNode("span", {
                "class": "login"
              }, "登录", -1)]);
            }),
            _: 1
          })])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return regUser(_unref(ruleFormRef));
            }),
            "class": "fasong"
          }, {
            "default": _withCtx(function () {
              return _cache[7] || (_cache[7] = [_createTextVNode("立即注册")]);
            }),
            _: 1
          })])])];
        }),
        _: 1
      }, 8, ["rules", "model"])])])])])])])])]);
    };
  }
});